<template>
  <el-card
      class-name="item-card"
      shadow="never"
      style="border-radius: 4px !important; border: 1px solid #dee5ec; margin-right: 12px;"
      body-style="margin: 8px;">
    <div
        class="flex flex-row"
        style="margin: 8px 8px 8px 8px">
      <div
          class="flex-1"
          style="margin: 7px">
        <div class="flex flex-row">
          <div
              class="item-name flex-1"
              style="margin-top: 7px !important;">
            USPS
          </div>
        </div>
        <div class="item-id">
          Track ID: &nbsp; <a
              :href="`https://www.swiship.com/track/?id=${trackingId}`"
              target="_blank">{{ trackingId }}</a>{{ }}
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
export default {
  name: "ReturnOrderShippingView",
  props: {
    trackingId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
};
</script>
